import React from 'react';
import { Activity, TrendingUp, Clock, Zap } from 'lucide-react';
// import { BannerAd } from '../components/GoogleAd'; // Uncomment when ready
import './Usage.css';

const Usage: React.FC = () => {
  // For testing: Show ads to ALL users (remove this after testing)
  // const isFreeUser = true; // Uncomment when ads are ready

  return (
    <div className="usage-page fade-in">
      {/* 📢 BANNER AD */}
      {/* {isFreeUser && <BannerAd />} */}
      
      <div className="page-header">
        <div>
          <h1>Usage & Statistics</h1>
          <p>Track your API usage and performance metrics</p>
        </div>
      </div>

      <div className="alert alert-info">
        <Activity size={20} />
        <span>This page is under development. Full analytics coming soon!</span>
      </div>

      <div className="grid grid-cols-4">
        <div className="stats-card">
          <div className="stats-card-header">
            <span className="stats-card-title">This Month</span>
            <div className="stats-card-icon">
              <Activity size={20} style={{ color: 'var(--color-primary)' }} />
            </div>
          </div>
          <div className="stats-card-value">1.2K</div>
          <div className="stats-card-change positive">
            <TrendingUp size={16} />
            +15% from last month
          </div>
        </div>

        <div className="stats-card">
          <div className="stats-card-header">
            <span className="stats-card-title">Avg Response</span>
            <div className="stats-card-icon">
              <Clock size={20} style={{ color: 'var(--color-info)' }} />
            </div>
          </div>
          <div className="stats-card-value">2.4s</div>
          <div className="stats-card-change positive">
            Excellent
          </div>
        </div>

        <div className="stats-card">
          <div className="stats-card-header">
            <span className="stats-card-title">Success Rate</span>
            <div className="stats-card-icon">
              <Zap size={20} style={{ color: 'var(--color-success)' }} />
            </div>
          </div>
          <div className="stats-card-value">99.8%</div>
          <div className="stats-card-change positive">
            Stable
          </div>
        </div>

        <div className="stats-card">
          <div className="stats-card-header">
            <span className="stats-card-title">Total Tokens</span>
            <div className="stats-card-icon">
              <Activity size={20} style={{ color: 'var(--color-warning)' }} />
            </div>
          </div>
          <div className="stats-card-value">45.2K</div>
          <div className="stats-card-change positive">
            <TrendingUp size={16} />
            +22% increase
          </div>
        </div>
      </div>
    </div>
  );
};

export default Usage;